<template>
  <div class="table-responsive" :class="divTableClass" :style="divTableStyle">
    <table class="table table-style" :class="tableClass" :style="tableStyle">
      <thead
        :class="{
          'table-head-theme-green':
            theme == 'green' || otherTheme == 'thead-green',
          'table-head-theme-gray': theme == 'gray',
        }"
      >
        <!--主標題(上)-->
        <tr
          v-if="$slots['header']"
          class="table-head-theme-green"
          style="border-bottom: 0px solid #999 !important"
        >
          <th
            :colspan="fields.length"
            style="font-family: dfyuanstd-w7; font-size: 1.125rem"
          >
            <slot name="header"></slot>
            <slot></slot>
          </th>
        </tr>
        <!--欄位標題-->
        <!-- 自定欄位標題 -->
        <slot v-if="$slots['thead-top']" name="thead-top"></slot>
        <!-- 原本欄位標題 -->
        <tr
          v-else
          :class="{
            stickyHeader: stickyHeader != null,
          }"
        >
          <template v-for="(field, index) in fields">
            <!-- 斜線標題 -->
            <template v-if="field.segmentation">
              <th :style="field.thStyle">
                <div class="table-head-line" :style="field.thDivStyle">
                  <span
                    class="table-head-top-item"
                    :style="field.tableHeadTopItem"
                    >{{ field.label[0] }}</span
                  >
                  <span
                    class="table-head-bottom-item"
                    :style="field.tableHeadBottomItem"
                    >{{ field.label[1] }}</span
                  >
                </div>
              </th>
            </template>
            <!-- 排序標題 -->
            <template v-else-if="field.sortable">
              <th
                @click="sortItems(field, index)"
                style="cursor: pointer"
                :style="field.thStyle"
              >
                <div :class="{ 'table-head-item': field.sortable }">
                  {{ field.label }}
                  <div
                    v-if="field.sortable"
                    class="table-head-div-sort-arrow table-head-div-sort-arrow-basic"
                    :class="{
                      'table-head-div-sort-arrow-basic': field.sortStatus == 0,
                      'table-head-div-sort-arrow-down': field.sortStatus == 1,
                      'table-head-div-sort-arrow-up': field.sortStatus == -1,
                    }"
                  ></div>
                </div>
              </th>
            </template>
            <!-- 一般標題 -->
            <template v-else>
              <th :style="field.thStyle">
                {{ field.label }}
              </th>
            </template>
          </template>
        </tr>
      </thead>
      <!-- </template> -->
      <tbody v-if="items.length != 0">
        <tr
          v-for="(item, key) in items"
          :class="{
            'table-body-theme-green':
              theme == 'green' || otherTheme == 'tbody-green',
            'cursor-pointer': rowClick != null,
          }"
          @click="rowClick != null ? rowClick(item) : ''"
        >
          <template v-for="field in fields">
            <!--slot條件欄位-->
            <template v-if="$slots['cell(' + field.key + ')']">
              <template v-if="field.rowspan == true">
                <td
                  v-if="item[field.key] != undefined"
                  :style="field.tdStyle"
                  :rowspan="item[field.rowspanKey]"
                >
                  <slot
                    :index="key"
                    :item="item"
                    :value="item[field.key]"
                    :name="'cell(' + field.key + ')'"
                  ></slot>
                </td>
              </template>
              <template v-else>
                <td :style="field.tdStyle">
                  <slot
                    :index="key"
                    :item="item"
                    :value="item[field.key]"
                    :name="'cell(' + field.key + ')'"
                  ></slot>
                </td>
              </template>
            </template>
            <template v-else>
              <!--斜線垂直標題欄位-->
              <td
                v-if="field.segmentation && item[field.key]"
                :style="{ background: field.segmentation.sub.background }"
                :rowspan="field.rowspan == true ? item[field.rowspanKey] : 1"
              >
                <div :style="field.tdStyle">
                  {{ item[field.key] }}
                </div>
              </td>
              <!--一般欄位-->
              <template v-else-if="field.rowspan == true">
                <td
                  v-if="item[field.key] != undefined"
                  :style="field.tdStyle"
                  :rowspan="item[field.rowspanKey]"
                >
                  {{ item[field.key] }}
                </td>
              </template>
              <!--一般欄位-->
              <td v-else :style="field.tdStyle">
                {{ item[field.key] }}
              </td>
            </template>
          </template>
        </tr>
      </tbody>
      <tfoot>
        <template v-if="extraItems.length != 0">
          <!-- 額外欄位 (例如: 總計) -->
          <tr>
            <!-- 不顯示欄位 -->
            <td
              v-if="fields.length - extraItems.length > 0"
              v-for="field in fields.length - extraItems.length"
              class="table-body-extra-none"
            ></td>
            <template v-for="(extraItem, extraIndex) in extraItems">
              <!-- 顯示欄位 -->
              <td
                class="table-body-extra-middle"
                :class="{
                  'table-body-extra-left': extraIndex == 0,
                  'table-body-extra-right': extraIndex == extraItems.length - 1,
                }"
                :style="
                  fields[fields.length - extraItems.length + extraIndex].tdStyle
                "
              >
                {{
                  isNaN(Number(extraItem))
                    ? extraItem
                    : Number(extraItem).toLocaleString("en-US")
                }}
              </td>
            </template>
          </tr>
        </template>
        <template v-if="$slots['footer']">
          <!--頁尾-->
          <tr v-if="$slots['footer']">
            <th
              :colspan="fields.length"
              style="font-family: dfyuanstd-w7; font-size: 1.125rem"
            >
              <slot name="footer"></slot>
              <slot></slot>
            </th>
          </tr>
        </template>
      </tfoot>
    </table>
  </div>
</template>

<script>
import { ref, watch } from "@vue/runtime-core";
export default {
  props: {
    fields: Array,
    items: {
      type: Array,
      default: [],
    },
    extraItems: {
      type: Array,
      default: [],
    },
    tableClass: String, //放在 <table> 的class 中
    tableStyle: Object,
    theme: {
      type: String,
      default: "gray",
    },
    otherTheme: {
      type: String,
      default: "",
    },
    divTableClass: String, // 放在table-responsive class 的div中
    divTableStyle: String,
    rowClick: {
      type: Function,
      default: null,
    },
    stickyHeader: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const fields = ref(props.fields);
    const items = ref(props.items);
    const stickyHeader = ref(props.stickyHeader);
    const divTableStyle = ref(props.divTableStyle);

    watch(
      () => props.fields,
      (newValue) => {
        fields.value = newValue;
      }
    );

    watch(
      () => props.items,
      (newValue) => {
        items.value = newValue;
      }
    );

    //整理Fields和Items的Style
    fields.value.forEach((data, index) => {
      //整理分隔線style
      if (data.segmentation) {
        //th 的高度
        let _thStyleHeight = "2.8rem";
        if (!data.thStyle) {
          data.thStyle = {};
          data.thStyle.height = _thStyleHeight;
        } else {
          if (!data.thStyle.height) {
            data.thStyle.height = _thStyleHeight;
          } else {
            _thStyleHeight = data.thStyle.height;
          }
        }

        //th 的寬度
        let _thStyleWidth = "5rem";
        if (!data.thStyle) {
          data.thStyle = {};
          data.thStyle.width = _thStyleWidth;
        } else {
          if (!data.thStyle.width) {
            data.thStyle.width = _thStyleWidth;
          } else {
            _thStyleWidth = data.thStyle.width;
          }
        }

        //分融線預設值
        let _supBackground = "#ccc";
        let _subBackground = "#bdbdbd";
        let _segmentation = {
          borderTop: _thStyleHeight + " solid " + _supBackground,
          borderleft: _thStyleWidth + " solid " + _subBackground,
        };

        //分隔線的 border-top 背景顏色
        if (data.segmentation.sup && data.segmentation.sup.background) {
          _segmentation.borderTop =
            _thStyleHeight + " solid " + data.segmentation.sup.background;
        } else {
          data.segmentation.sup = {};
          data.segmentation.sup.background = _supBackground;
        }

        //分隔線的 border-left 背景顏色
        if (data.segmentation.sub && data.segmentation.sub.background) {
          _segmentation.borderleft =
            _thStyleWidth + " solid " + data.segmentation.sub.background;
        } else {
          data.segmentation.sub = {};
          data.segmentation.sub.background = _subBackground;
        }

        //標題行顏色
        fields.value.forEach((data2, index2) => {
          if (index2 == index) {
            //斜線標題以sup顏色為主
            if (data2.thStyle && data2.thStyle.background) {
              delete data2.thStyle.background;
            }
          } else if (index2 > index) {
            if (!data2.thStyle) {
              data2.thStyle = {
                background: data.segmentation.sup.background + " !important",
              };
            } else if (data2.thStyle && !data2.thStyle.background) {
              data2.thStyle.background =
                data.segmentation.sup.background + " !important";
            }
            fields.value[index2] = data2;
          }
        });

        //設定分隔線
        data.thDivStyle = {
          "border-top": _segmentation.borderTop,
          "border-left": _segmentation.borderleft,
        };

        //設定左下文字位置
        data.tableHeadBottomItem = {
          bottom: 0,
          left: "-" + _thStyleWidth,
        };

        //設定右上文字位置
        data.tableHeadTopItem = {
          top: "-" + _thStyleHeight,
          right: 0,
        };
      }

      fields.value[index] = data;
    });

    //點擊時排序
    const sortItems = (fieldData, fieldIndex) => {
      // if (items.value.length == 0) {
      //   return;
      // }
      if (fieldData.sortStatus == undefined) {
        fields.value[fieldIndex].sortStatus = 0;
      }
      switch (fields.value[fieldIndex].sortStatus) {
        case 0:
        case 1:
          items.value.sort(function (a, b) {
            if (a[fieldData.key] > b[fieldData.key]) {
              return 1;
            } else if (a[fieldData.key] < b[fieldData.key]) {
              return -1;
            }
            return 0;
          });
          fields.value.forEach((element, index) => {
            if (element.key != fieldData.key) {
              fields.value[index].sortStatus = 0;
            } else {
              fields.value[index].sortStatus = -1;
            }
          });
          break;
        case -1:
          items.value.sort(function (a, b) {
            if (a[fieldData.key] > b[fieldData.key]) {
              return -1;
            } else if (a[fieldData.key] < b[fieldData.key]) {
              return 1;
            }
            return 0;
          });
          fields.value.forEach((element, index) => {
            if (element.key != fieldData.key) {
              fields.value[index].sortStatus = 0;
            } else {
              fields.value[index].sortStatus = 1;
            }
          });
          break;
      }
    };
    if (stickyHeader.value != null) {
      divTableStyle.value += `;max-height: ${stickyHeader.value};`;
    }

    return {
      sortItems,
      fields,
      items,
      divTableStyle,
    };
  },
};
</script>

<style>
.table > :not(:first-child) {
  border-top: 0px solid currentColor;
}
.table-style {
  width: 100%;
  border-collapse: separate;
  /* border-collapse: collapse; */
  border-spacing: 0;
  margin-bottom: 0px;
}
.table-style td,
.table-style th {
  font-family: "dfyuanstd-w5";
  font-size: 18px;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999;
  border-bottom: 1px solid #999;
  border-right: 1px solid #999;
  font-weight: 400;
  background-color: var(--main-font-color);
  vertical-align: middle;
  height: 2.8rem;
}
/*   padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem; */

/* .table-style thead th { */
.table-style thead tr:first-child th {
  /* color: #000 !important;
  background-color: #ccc; */
  border-color: #999 !important;
  border-top: 1px solid;
}

.table-head-theme-gray th {
  color: #000;
  background-color: #ccc;
}

.table-head-theme-green th {
  color: var(--main-font-color);
  background-color: var(--main-bg-color);
}

.table-style td:first-child,
.table-style th:first-child {
  border-left: 1px solid #999;
}

.table-head-item {
  position: relative;
  padding: 0px 20px 0px 0px;
  text-align: center;
}

.table-head-div-sort-arrow {
  background-size: 100% 100%;
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
  width: 11px;
}

.table-head-div-sort-arrow-basic {
  /* background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' preserveAspectRatio='none'%3E%3Cpath opacity='.3' d='M51 1l25 23 24 22H1l25-22zm0 100l25-23 24-22H1l25 22z'/%3E%3C/svg%3E"); */
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' preserveAspectRatio='none'%3E%3Cpath fill='%23fff' opacity='.3' d='M51 1l25 23 24 22H1l25-22zm0 100l25-23 24-22H1l25 22z'/%3E%3C/svg%3E");
}

.table-head-div-sort-arrow-up {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' preserveAspectRatio='none'%3E%3Cpath fill='%23fff' d='M51 1l25 23 24 22H1l25-22z'/%3E%3Cpath fill='%23fff' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3E%3C/svg%3E");
}

.table-head-div-sort-arrow-down {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27101%27 height=%27101%27 preserveAspectRatio=%27none%27%3E%3Cpath fill=%27%23fff%27 opacity=%27.3%27 d=%27M51 1l25 23 24 22H1l25-22z%27/%3E%3Cpath fill=%27%23fff%27 d=%27M51 101l25-23 24-22H1l25 22z%27/%3E%3C/svg%3E");
}

.table-head-line {
  /* border-top: 2.8rem solid #ccc; */
  width: 0;
  height: 0;
  /* border-left: 5rem solid #bdbdbd; */
  position: relative;
  color: #000;
}

.table-head-top-item,
.table-head-bottom-item {
  white-space: nowrap;
  font-style: normal;
  /* display: table; */
  position: absolute;
  /* width: 2.8rem; */
  font-family: dfyuanstd-w5;
}

.table-body-theme-green:nth-child(even) td {
  background-color: rgba(75, 140, 128, 0.2);
}

.table-style td.table-body-extra-none {
  background-color: transparent;
  border: 1px transparent solid;
}

.table-style td.table-body-extra-left {
  border-left: 2px var(--main-status-danger-color) solid;
}

.table-style td.table-body-extra-middle {
  border-bottom: 2px var(--main-status-danger-color) solid;
  border-top: 2px var(--main-status-danger-color) solid;
}

.table-style td.table-body-extra-right {
  border-right: 2px var(--main-status-danger-color) solid;
}

.stickyHeader {
  position: sticky;
  top: 0;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
